import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const DownloadText = ({ show }) => (show ? <FormattedMessage id="common.download" /> : null);

DownloadText.propTypes = {
  /**
   * Muestra o no el mensaje
   **/
  show: PropTypes.bool,
};

export default DownloadText;
